export const parsePromptChainsSearchParams = (searchParams) => {
    const page = Number.parseInt(searchParams.get('page'));
    const sort = searchParams.get('sort');

    return { page, sort };
};
